import { h } from 'preact';
import { Router } from 'preact-router';

import Header from './header';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import Projects from '../routes/projects';
import Resume from '../routes/resume';
import Contact from '../routes/contact';

const App = () => (
	<div id="app">
		<Header />
		<Router>
			<Home path="/" />
			<Projects path="/projects" />
			<Resume path="/resume" />
			<Contact path="/contact" />
		</Router>
	</div>
)

export default App;
